import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-correction-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './correction-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './correction-staff-member.component.scss',
})
export class CorrectionStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() fix = new EventEmitter<StaffMember>();
  @Output() exclude = new EventEmitter<StaffMember>();

}
